import styled from "styled-components";

export const StyledDotsLoaderWrapper = styled.div`
    padding-left: 46px;
`;
